<script setup lang="ts">
import { useLineRichMenuEditPageQuery } from './LineRichMenuEditPage.generated'
import LineRichMenuEditPageContent from './LineRichMenuEditPageContent.vue'
import LineMessageSendingIndexPageSideMenu from '@/pages/ChatMessageSendingJobIndexPage/ChatMessageSendingJobIndexPageSideMenu.vue'
import CenteredPageContainer from '@/components/molecules/CenteredPageContainer.vue'
import { useRoute } from 'vue-router'

const route = useRoute('LineRichMenuEditPage')
const lineRichMenuGUID = route.params.lineRichMenuGUID
const pageQuery = useLineRichMenuEditPageQuery(
  {
    guid: lineRichMenuGUID,
  },
  {
    fetchPolicy: 'no-cache',
  }
)
</script>

<template>
  <CenteredPageContainer :class="$style.page" wide>
    <div :class="[$style.page__main, $style.setting]">
      <LineMessageSendingIndexPageSideMenu />
      <section :class="$style.wrapper">
        <div :class="$style.container">
          <LineRichMenuEditPageContent
            v-if="pageQuery.result.value"
            :payload="pageQuery.result.value.lineRichMenu.lineRichMenu"
          />
        </div>
      </section>
    </div>
  </CenteredPageContainer>
</template>

<style module lang="scss">
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 auto;
  width: 100%;
}

.container {
  background-color: $color-surface-primary;
  padding: 16px;
  border-radius: 10px;
}

.page {
  padding-bottom: 80px;

  &__header {
    &:nth-child(n + 2) {
      margin-top: 40px;
    }
  }

  &__main {
    &:nth-child(n + 2) {
      margin-top: 32px;
    }
  }
}

.setting {
  display: grid;
  align-items: flex-start;
  gap: 40px;
  grid-template-columns: 302px 1fr;
  grid-template-rows: auto;
}
</style>
